import * as signalR from "@microsoft/signalr";

const appendQueryParameters = (hubUrl, queryParameters) => {
  if (!queryParameters || Object.keys(queryParameters).length === 0) {
    return hubUrl;
  }

  const [baseUrl, hash = ""] = String(hubUrl).split("#");
  const [path, query = ""] = baseUrl.split("?");
  const searchParams = new URLSearchParams(query);

  Object.entries(queryParameters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    searchParams.set(key, value);
  });

  const nextQuery = searchParams.toString();
  return `${path}${nextQuery ? `?${nextQuery}` : ""}${hash ? `#${hash}` : ""}`;
};

export const createCallHubConnection = ({
  hubUrl,
  accessTokenFactory,
  queryParameters,
  automaticReconnect = true,
  logger = signalR.LogLevel.Warning,
  withCredentials = true,
} = {}) => {
  if (!hubUrl) {
    throw new Error("hubUrl is required to create a call hub connection.");
  }

  let builder = new signalR.HubConnectionBuilder().withUrl(
    appendQueryParameters(hubUrl, queryParameters),
    {
      accessTokenFactory,
      withCredentials,
    },
  );

  if (automaticReconnect) {
    const defaultDelays = [0, 1000, 2000, 4000, 8000, 15000, 30000, 60000];
    builder = Array.isArray(automaticReconnect)
      ? builder.withAutomaticReconnect(automaticReconnect)
      : builder.withAutomaticReconnect(defaultDelays);
  }

  if (logger !== undefined && logger !== null) {
    builder = builder.configureLogging(logger);
  }

  return builder.build();
};

export { signalR };
